module.exports = new __parcel__URL__("connect-workflow.ff34ac9a.svg").toString();